import * as angular from "angular";
import {LeagueResource} from "./resource/LeagueResource";
import {ContestantResource} from "./resource/ContestantResource";
import {MatchResource} from "./resource/MatchResource";
import {TextblockResource} from "./resource/TextblockResource";
import {GameAccountResource} from "./resource/GameAccountResource";
import {GameResource} from "./resource/GameResource";
import {FranchiseResource} from "./resource/FranchiseResource";
import {GameAccountDescriptionResource} from "./resource/GameAccountDescriptionResource";
import {TeamResource} from "./resource/TeamResource";
import {UserResource} from "./resource/UserResource";
import {GameAccountTypeResource} from "./resource/GameAccountTypeResource";
import {RosterResource} from "./resource/RosterResource";
import {LeagueService} from "./service/LeagueService";
import {ContestantService} from "./service/ContestantService";
import {GameAccountService} from "./service/GameAccountService";
import {MatchService} from "./service/MatchService";
import {GameService} from "./service/GameService";
import {FranchiseService} from "./service/FranchiseService";
import {GameAccountDescriptionService} from "./service/GameAccountDescriptionService";
import {TeamService} from "./service/TeamService";
import {UserService} from "./service/UserService";
import {GameAccountTypeService} from "./service/GameAccountTypeService";
import {RosterService} from "./service/RosterService";
import {GameAccountBuilder} from "./service/GameAccountBuilder";
import {IApiEndPointsProvider} from "./typings/apiEndpoints";

/**
 * @ngdoc overview
 * @type {IModule}
 *
 * @name ngLeague
 *
 * @description
 *
 * The ngLeague module allows developers to access the ESL Play API using AngularJS. It does not handle authenticating
 * requests or user management at this time, only competition management.
 *
 * You can use the various services to get plain old JS objects from the API that represent leagues, matches, contestants
 * etc. If you need to make direct calls to the API and use the JSON responses the resources are also directly exposed.
 */

export const ngLeague: angular.IModule = angular.module('ngLeague', []);

ngLeague.provider('ApiEndpoints', function ApiEndpointsProvider(): IApiEndPointsProvider {

    this.baseUrl = 'https://api.eslgaming.com/';
    this.xapiBaseUrl = '//play.eslgaming.com/';

    this.endpoints = {
        league: 'play/v1/leagues',
        gameAccount: 'play/v1/user/gameaccounts',
        match: 'play/v1/matches',
        userLeague: 'play/v1/user/leagues',
        userTeam: 'play/v1/user/teams',
        userPremium: 'play/v1/user/premium',
        userProfileShort: 'play/v1/user/short_profile',
        userProfileBasic: 'play/v1/users/~/basicprofile',
        userProfileFull: 'play/v1/user/profile',
        user: 'play/v1/users',
        game: 'play/v1/games',
        team: 'play/v1/teams',
        gameAccountType: 'play/v1/gameaccounts',
        gameAccountDescription: 'xapi/gameaccounts'
    };

    this.$get = function () {
        return {
            league: this.baseUrl + this.endpoints.league,
            gameAccount: this.baseUrl + this.endpoints.gameAccount,
            match: this.baseUrl + this.endpoints.match,
            userLeague: this.baseUrl + this.endpoints.userLeague,
            userTeam: this.baseUrl + this.endpoints.userTeam,
            userPremium: this.baseUrl + this.endpoints.userPremium,
            user: this.baseUrl + this.endpoints.user,
            userProfileShort: this.baseUrl + this.endpoints.userProfileShort,
            userProfileBasic: this.baseUrl + this.endpoints.userProfileBasic,
            userProfileFull: this.baseUrl + this.endpoints.userProfileFull,
            game: this.baseUrl + this.endpoints.game,
            team: this.baseUrl + this.endpoints.team,
            gameAccountType: this.baseUrl + this.endpoints.gameAccountType,
            gameAccountDescription: this.xapiBaseUrl + this.endpoints.gameAccountDescription
        };
    };

    return this;
});

ngLeague.service("LeagueResource", LeagueResource);
ngLeague.service("ContestantResource", ContestantResource);
ngLeague.service("MatchResource", MatchResource);
ngLeague.service("TextblockResource", TextblockResource);
ngLeague.service("GameAccountResource", GameAccountResource);
ngLeague.service("GameResource", GameResource);
ngLeague.service("FranchiseResource", FranchiseResource);
ngLeague.service("GameAccountDescriptionResource", GameAccountDescriptionResource);
ngLeague.service("TeamResource", TeamResource);
ngLeague.service("UserResource", UserResource);
ngLeague.service("GameAccountTypeResource", GameAccountTypeResource);
ngLeague.service("RosterResource", RosterResource);

ngLeague.service("LeagueService", LeagueService);
ngLeague.service("ContestantService", ContestantService);
ngLeague.service("GameAccountService", GameAccountService);
ngLeague.service("MatchService", MatchService);
ngLeague.service("GameService", GameService);
ngLeague.service("FranchiseService", FranchiseService);
ngLeague.service("GameAccountDescriptionService", GameAccountDescriptionService);
ngLeague.service("TeamService", TeamService);
ngLeague.service("UserService", UserService);
ngLeague.service("GameAccountTypeService", GameAccountTypeService);
ngLeague.service("RosterService", RosterService);
ngLeague.service("GameAccountBuilder", GameAccountBuilder);